module.exports = __webpack_public_path__ + "media/glair.00fb8988.wav";